import {ClientService} from '../../libs/ui/src';
import {client} from '../apiService';

const _ClientService = new ClientService({client});

export {_ClientService as ClientService};
